<template>
  <v-menu
    absolute
    offset-y
    style="max-width: 400px"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
          <v-btn
            color="primary"
            x-large
            icon
            v-bind="{ ...attrs, ...attrsTooltip }"
            v-on="{ ...on, ...onTooltip }"
          >
            <v-icon> mdi-database-search </v-icon>
          </v-btn>
        </template>
        <div>
          {{ $t('notificationMetadata') }}
        </div>
      </v-tooltip>
    </template>
    <v-card class="portrait" width="400">
      <v-card-title>
        {{ $t('notificationMetadata') }}
      </v-card-title>
      <v-card-text>
        <!-- Primero mostramos los metadatos extraidos del Concepto, si los hay, y solo si tiene contenido -->
        <div
          v-for="(metadata, i) in notification.conceptoMetadatos"
          :key="'metadata-concept-' + i"
        >
          <span
            v-for="(key, n) in filteredKeys(metadata)"
            :key="'metadata-key-value-' + n"
          >
            - <b>{{ $t('metadata.' + key) }}</b
            >: {{ metadata[key] }}
            <br />
          </span>
        </div>
        <!-- y despues los metadatos extraidos del documento, si los hay -->
        <div
          v-for="(metadata, i) in notification.metadatas"
          :key="'metadata-file-' + i"
        >
          <span
            v-for="(key, n) in Object.keys(metadata)"
            :key="'metadata-key-value-' + n"
          >
            <template v-if="shouldShowMetadata(metadata, key)">
              - <b>{{ $t('metadata.' + key) }}</b
              >:
              {{
                key === 'tipo' &&
                !metadata.tipoXML &&
                metadata[key] !== 'AEAT_RE02'
                  ? $t('metadata.types.' + metadata[key])
                  : key === 'tipoXML' &&
                    metadata.tipo &&
                    metadata[key] !== metadata.tipo
                  ? metadata[key]
                  : metadata[key]
              }}
              <br />
            </template>
          </span>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    notification: Object,
  },
  computed: {
    ...mapGetters(['isAdminUser']),
  },
  methods: {
    filteredKeys(metadata) {
      return Object.keys(metadata).filter(
        (key) => metadata[key] !== '' && metadata[key] != null
      )
    },
    shouldShowMetadata(metadata, key) {
      // Pares de metadatos a comparar
      const pairs = [
        ['oficinaRemitente', 'oficinaRemitenteXML'],
        ['claveAplicacion', 'claveAplicacionXML'],
        ['numeroReferenciaDocumento', 'claveAplicacionXML'],
        ['tipo', 'tipoXML'],
      ]

      for (const [normal, xml] of pairs) {
        // Caso 1: si el key actual es el XML y hay otro sin sufijo con el mismo valor : no mostrar el XML
        if (
          key === xml &&
          metadata[normal] !== undefined &&
          metadata[normal] === metadata[xml]
        ) {
          return false
        }

        // Caso 2: si el key actual es el normal y hay otro XML con el mismo valor : mostrar solo el normal
        if (
          key === normal &&
          metadata[xml] !== undefined &&
          metadata[normal] === metadata[xml]
        ) {
          return true
        }
      }

      // En cualquier otro caso, mostrar siempre los dos
      return true
    },
  },
}
</script>
